import React, { Component, PureComponent } from 'react'
import DataTable from '../datatable'

const columns = [
  {
    name: 'name',
    label: 'Nimi',
    sortable: true,
    id: true,
  },
  {
    name: 'email',
    label: 'Sähköposti',
    sortable: true,
    id: true,
  },
  {
    name: 'lang',
    label: 'Kieli',
    sortable: true,
  },
  {
    name: 'role',
    label: 'Admin',
    render(item) {
      return <div>{item.get('admin') ? 'Kyllä' : 'Ei'}</div>
    },
  },
  {
    name: 'user_role_id',
    label: 'Käyttörooli',
    render(item) {
      return <div>{item.get('user_role_id')}</div>
    },
  },
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
  },
]

export default function ProductRoot() {
  return (
    <DataTable
      id="users"
      entity="user"
      crud
      title="Käyttäjät"
      texts={{ createButton: 'Lisää käyttäjä' }}
      columns={columns}
    />
  )
}
